import React from 'react';
import { toast } from 'react-toastify';

export default {
  success: toast.success,

  error: (message) => toast.error(message, { autoClose: false }),

  warning: (message, isNodeElement, autoCloseTime = 30000) => {
    if (!isNodeElement) toast.warning(message, { autoClose: false });
    else {
      toast.warning(
        <span dangerouslySetInnerHTML={{ __html: message }} />,
        { closeOnClick: false, closeButton: true, autoClose: autoCloseTime },
      );
    }
  },
};
